import React, { useCallback, useState, useEffect } from 'react';
import * as PropTypes from 'prop-types';
import endpoints from '../../define/endpoints';
import Cookies from 'universal-cookie';
import Icon from '@iconify/react';
import iconLogout from '@iconify-icons/mdi/location-exit';
import { Modal } from '../modals/Modal';
import { ModalClose } from '../modals/ModalClose';

const UserBanner = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const cookies = new Cookies();
  var welfare_user = cookies.get('welfare_user');
  const queryParameters = new URLSearchParams(window.location.search);
  var logo = null;
  switch (welfare_user.provider) {
    case 'wtw': logo = 'logo-wtw.png'; break;
    case 'wellwork': logo = 'logo-wellwork.png'; break;
    case 'howden': logo = 'logo-howden.png'; break;
    case 'jointly': logo = 'logo-jointly.svg'; break;
    default: break;
  }

  const logout = useCallback(() => {
    const cookies = new Cookies();
    cookies.remove('welfare_user', { path: '/' });
    cookies.remove(`${welfare_user.provider}_user`, { path: '/' });
    window.location.reload(true);
  }, []);

  const clearUrl = useCallback(() => {
    setIsModalOpen(false);
    window.history.replaceState({}, document.title, '/');
  }, []);

  useEffect(() => {
    setIsModalOpen(queryParameters.get('checkout_error') === 'welfare_user');
  }, []);

  const modal = (
    <Modal
      onClickOverlay={() => clearUrl()}
      isOpen={isModalOpen}
      shouldScroll={false}
    >
      <div className={`modal-partner-signup`} style={{ width: 370 }}>
        <ModalClose onClick={() => clearUrl()} />
        <span style={{ 'margin-top': '10px' }}>{app_main_wpml.welfare_info}.</span>
      </div>
    </Modal>
  );

  return (
    <div className='external-banner'>
      {modal}
      <div className='content'>
        <img
          src={endpoints.bucket + 'images/' + logo}
          className="welfare__logo"
        />
        <div>
          <p>{welfare_user.firstName} {welfare_user.lastName} <span>({welfare_user.credit} {app_main_wpml.lc_points})</span> </p>
          <span className='hide_string'>|</span>
          <a onClick={logout}><span className='hide_string'>{app_main_wpml.log_out}</span><Icon icon={iconLogout} className="icon" /></a>
        </div>
      </div>
    </div>
  );
};

UserBanner.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  credit: PropTypes.string
};

export default UserBanner;
export { UserBanner };